// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__nMQeC","inner":"Footer_inner__3uux5"};